import { Component, Vue } from 'vue-property-decorator';

const MOSCOW_REGION_DOP: string = 'dop50.ru';
const MOSCOW_REGION_MOSREG: string = 'dop.mosreg.ru';
const MOSCOW_REGION_NEW: string = 'new.dop.mosreg.ru';
const URLS: Array<string> = [
  MOSCOW_REGION_DOP,
  MOSCOW_REGION_MOSREG,
  MOSCOW_REGION_NEW,
];

const MOSREGUSLUGI = 'https://uslugi.mosreg.ru/services/20712';

@Component
export default class IsLocationMixin extends Vue {
  locationUrl: boolean = false;
  isAppLoading: boolean = true;
  readonly mosRegUslugiLink: string = MOSREGUSLUGI;

  get noRegistrationOrOrder(): boolean {
    const { locationUrl, isAppLoading } = this;
    return isAppLoading || locationUrl;
  }

  mounted() {
    this.$nextTick(() => {
      if (window.location && URLS.includes(window.location.host)) {
        this.locationUrl = true;
      }
      this.isAppLoading = false;
    });
  }

  isRegistrationLink() {
    const { noRegistrationOrOrder, mosRegUslugiLink } = this;
    return noRegistrationOrOrder ? mosRegUslugiLink : '';
  }
}



// WEBPACK FOOTER //
// ./src/mixins/isLocation.ts